define('controller/step/datetime/FlexibleWeeklyDateTimeStep',['require','controller/step/datetime/BaseWeeklyDateTimeStep','collection/TimeFlexibleCollection','view/controller/booking/datetime/flexible-weekly/TimeFlexibleWeeklyView'],function (require) {

    var BaseWeeklyDateTimeStep = require('controller/step/datetime/BaseWeeklyDateTimeStep');
    var TimeFlexibleCollection = require('collection/TimeFlexibleCollection');
    var TimeFlexibleWeeklyView = require('view/controller/booking/datetime/flexible-weekly/TimeFlexibleWeeklyView');

    return BaseWeeklyDateTimeStep.extend({

        _timeCollection: null,

        /**
         * Inits time collection
         */
        _initTimeCollection: function () {
            this._timeCollection = new TimeFlexibleCollection();
        },

        /**
         * Returns time view
         *
         * @return TimeFlexibleView
         */
        _getTimeView: function () {
            var view = new TimeFlexibleWeeklyView({
                model: this._bookingModel,
                bookingModel: this._bookingModel,
                calendarCollection: this._calendarCollection,
                timeCollection: this._timeCollection,
                timeValidateModel: this._timeValidateModel,
                clientTimeZone: this.getOption('clientTimeZone'),
                showNavigation: this._supportsTimelineNavigation,
                selectedDates: this._getSelectedDates(),
                waitingListHelperModel: this.getOption('waitingListHelperModel'),
            });

            this.listenTo(view, 'timeChanged', this._updateSelectedTime);

            return view;
        }

    });

});
